export const SET_CREATE_ICP_FILTERS = 'SET_CREATE_ICP_FILTERS';
export const setCreateICPFilters = (filterData: any) => ({
  type: SET_CREATE_ICP_FILTERS,
  payload: filterData,
});

export const SET_DESIGNATION_FILTER_PRIORIY = 'SET_DESIGNATION_FILTER_PRIORIY';
export const setDesignationFitlerPriority = (values: string[]) => ({
  type: SET_DESIGNATION_FILTER_PRIORIY,
  payload: values,
});
export const SET_JOBTITLE_FILTER_PRIORIY = 'SET_JOBTITLE_FILTER_PRIORIY';
export const setJobTitleFitlerPriority = (values: string[]) => ({
  type: SET_JOBTITLE_FILTER_PRIORIY,
  payload: values,
});
export const SET_DEPARTMENT_FILTER_PRIORIY = 'SET_DEPARTMENT_FILTER_PRIORIY';
export const setDeparmentFitlerPriority = (values: string[]) => ({
  type: SET_DEPARTMENT_FILTER_PRIORIY,
  payload: values,
});

const initialState: any = {};

interface Action {
  type: string;
  payload: any;
}

const createICPFilterReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_CREATE_ICP_FILTERS:
      return {
        ...action.payload,
      };
    case SET_DESIGNATION_FILTER_PRIORIY:
      return {
        ...state,
        designation: {
          ...state.designation,
          filterData: { ...state.designation.filterData, includes: action.payload },
        },
      };
    case SET_JOBTITLE_FILTER_PRIORIY:
      return {
        ...state,
        jobTitle: {
          ...state.jobTitle,
          filterData: { ...state.jobTitle.filterData, includes: action.payload },
        },
      };
    case SET_DEPARTMENT_FILTER_PRIORIY:
      return {
        ...state,
        department: {
          ...state.department,
          filterData: { ...state.department.filterData, includes: action.payload },
        },
      };
    default:
      return state;
  }
};
export default createICPFilterReducer;
